import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter, HashRouter } from "react-router-dom";

const rootElement = document.getElementById("root");
ReactDOM.render(
    <GoogleOAuthProvider clientId="492337970304-15g1qnsg7eeu4jblkn64p28r8cut9i1k.apps.googleusercontent.com" >
    <BrowserRouter>
    <App />
    </BrowserRouter>
    </GoogleOAuthProvider>
, rootElement);
